import { render } from "./Gallery.vue?vue&type=template&id=05ee2bd0"
import script from "./Gallery.vue?vue&type=script&setup=true&lang=js"
export * from "./Gallery.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paragraphs/Gallery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05ee2bd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05ee2bd0', __exports__)) {
    api.reload('05ee2bd0', __exports__)
  }
  
  module.hot.accept("./Gallery.vue?vue&type=template&id=05ee2bd0", () => {
    api.rerender('05ee2bd0', render)
  })

}


export default __exports__